/* Approved Terms page interactions, scoped to the Terms template. */
(() => {
  const contents = document.querySelector('.nano-terms-page .mobile-contents');
  const page = document.querySelector('.nano-terms-page .privacy-page');
  const targets = [...document.querySelectorAll('.nano-terms-page .policy-section h2, .nano-terms-page .privacy-choices h2')];
  const links = [...document.querySelectorAll('.nano-terms-page .contents-links a, .nano-terms-page .mobile-contents nav a')];
  const mobilePolicy = matchMedia('(max-width:900px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  function offset() { return mobilePolicy.matches ? 76 : 24; }
  function highlight() {
    const threshold = offset() + 28;
    let active = targets[0];
    for (const target of targets) {
      if (target.getBoundingClientRect().top <= threshold) active = target;
    }
    links.forEach(link => {
      if (new URL(link.href).hash === '#' + active.id) link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    });
  }
  let queued = false;
  addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { highlight(); queued = false; });
  }, {passive:true});
  page.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    contents.open = false;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
    const top = target.id === 'top' ? 0 : target.getBoundingClientRect().top + scrollY - offset();
    history.pushState(null,'',location.pathname + location.search + url.hash);
    scrollTo({top:Math.max(0,top),behavior:reduced.matches?'instant':'smooth'});
  });
  contents.addEventListener('keydown', event => {
    if(event.key==='Escape' && contents.open){contents.open=false;contents.querySelector('summary').focus();}
  });
  mobilePolicy.addEventListener('change', () => { contents.open=false;highlight(); });
  addEventListener('resize',highlight);
  addEventListener('hashchange',highlight);
  highlight();
})();

